import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { Logo } from '../Logo';
import { Button } from '../Button';
const NAV_ITEMS: {
  label: string;
  href: string;
}[] = [{
  label: '課題',
  href: '#problem'
}, {
  label: 'AI受付スタッフ',
  href: '#ai-staff'
}, {
  label: '導入の流れ',
  href: '#process'
}, {
  label: 'よくある質問',
  href: '#faq'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  /** Scroll to an in-page section, navigating home first if we're on another route. */
  const goToSection = (href: string) => {
    setOpen(false);
    if (location.pathname !== '/') {
      navigate('/' + href);
      return;
    }
    document.querySelector(href)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    goToSection(href);
  };
  const goHome = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    goToSection('#top');
  };
  return <header className="sticky top-0 z-50 w-full border-b border-border bg-white/90 backdrop-blur" data-id="element-216" data-mp="yqsui2xphyd4">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-217" data-mp="12se8jrlz8iow">
        <a href="/" onClick={goHome} className="shrink-0 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-deep-navy" aria-label="OptiDSA ホーム" data-id="element-218" data-mp="1qi8ncepuwhbs">
          <Logo size="sm" data-id="element-219" data-mp="1hq6qsriwrl6s" />
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="メインナビゲーション" data-id="element-220" data-mp="1hp5c8d2oogkb">
          {NAV_ITEMS.map(item => <a key={item.href} href={item.href} onClick={e => handleNav(e, item.href)} className="text-sm font-medium text-text-muted transition-colors hover:text-deep-navy focus:outline-none focus-visible:text-deep-navy" data-id="element-221" data-mp="29gb6wdzmxm27">
              {item.label}
            </a>)}
          <RouterLink to="/about" onClick={() => setOpen(false)} className="text-sm font-medium text-text-muted transition-colors hover:text-deep-navy focus:outline-none focus-visible:text-deep-navy" data-id="element-222" data-mp="2k2pyuyqg50rm">
            会社概要
          </RouterLink>
        </nav>

        <div className="flex items-center gap-2" data-id="element-223" data-mp="255yyon8y7l0y">
          <div className="hidden sm:block" data-id="element-224" data-mp="20dfj5kqpafti">
            <Button variant="primary" size="sm" onClick={() => goToSection('#contact')} data-id="element-225" data-mp="20cnyv62k04ij">
              お問い合わせ
            </Button>
          </div>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-md text-deep-navy md:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-deep-navy" aria-label={open ? 'メニューを閉じる' : 'メニューを開く'} aria-expanded={open} onClick={() => setOpen(v => !v)} data-id="element-226" data-mp="1rf3v9qh7xw4r">
            {open ? <XIcon className="h-6 w-6" data-id="element-227" data-mp="1c8elnyj1l8xs" /> : <MenuIcon className="h-6 w-6" data-id="element-228" data-mp="1h92mfbx2p457" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-border bg-white md:hidden" data-id="element-229" data-mp="1m74721a5dbis">
          <nav className="mx-auto flex max-w-6xl flex-col px-4 py-2 sm:px-6" aria-label="モバイルナビゲーション" data-id="element-230" data-mp="ol6rocr2dmb2">
            {NAV_ITEMS.map(item => <a key={item.href} href={item.href} onClick={e => handleNav(e, item.href)} className="rounded-md px-2 py-3 text-base font-medium text-text transition-colors hover:bg-surface-muted" data-id="element-231" data-mp="yiuqpevpdfz1">
                {item.label}
              </a>)}
            <RouterLink to="/about" onClick={() => setOpen(false)} className="rounded-md px-2 py-3 text-base font-medium text-text transition-colors hover:bg-surface-muted" data-id="element-232" data-mp="as8hvldvjrnz">
              会社概要
            </RouterLink>
            <div className="px-2 py-3" data-id="element-233" data-mp="2m7zahw08ns5k">
              <Button variant="primary" size="md" onClick={() => goToSection('#contact')} className="w-full" data-id="element-234" data-mp="2m9ttv5vv3c7j">
                お問い合わせ
              </Button>
            </div>
          </nav>
        </div>}
    </header>;
}